import { cn } from "@/lib/utils";

const RadioDot = ({ checked }: { checked: boolean }) => {
  return (
    <div
      className={cn(
        "h-4 w-4 shrink-0 rounded-full border flex items-center justify-center bg-white",
        checked ? "border-primary" : "border-muted-foreground/40",
      )}
      aria-hidden="true">
      {checked ? <div className="h-2 w-2 shrink-0 rounded-full bg-primary" /> : null}
    </div>
  );
};

export default RadioDot;
